export default {"src":"/_next/static/media/itc.cf4372b9.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};